import { useRef, useState } from 'react';
import { styled } from '@mui/material/styles';
import NoteInfoAccordion from './NoteInfoAccordion';
import NoteSocialSection from './NoteSocialSection';
import NoteAuthorSection from './NoteAuthorSection';
import MakeComment from './MakeComment';

const NoteInfoContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '320px',
  marginLeft: '23px',

  [theme.breakpoints.down('950')]: {
    width: '250px',
    margin: '0',
  },

  [theme.breakpoints.down('750')]: {
    width: 'auto',
    padding: '0px 20px 0 15px',
    margin: '0',
  },
}));

const MakeCommentContainer = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('750')]: {},
}));

const NoteInfo = (props) => {
  const [commentData, setCommentData] = useState({});
  const commentInputRef = useRef(null);

  const replyComment = (data) => {
    commentInputRef.current.focus();
    setCommentData(data);
  };
  const clearCommentData = () => {
    setCommentData({});
  };

  const TitleLine = styled('span')(({ theme }) => ({
    width: '100%',
    borderBottom: '2px solid rgb(166,146,123)',
    [theme.breakpoints.down('750')]: {
      display: 'none',
    },
  }));

  const [isCommentIconClicked, setIsCommentIconClicked] = useState(false);
  window.addEventListener('resize', () => {
    if (window.innerWidth > 750) {
      setIsCommentIconClicked(true);
    } else if (window.innerWidth <= 750) {
      setIsCommentIconClicked(false);
    }
  });
  window.addEventListener('load', () => {
    if (window.innerWidth > 750) {
      setIsCommentIconClicked(true);
    }
  });
  const handleClick = (event) => {
    setIsCommentIconClicked(!isCommentIconClicked);
  };

  let responsiveProps = Object.assign({}, props);
  responsiveProps.isResponsive = true;
  return (
    <NoteInfoContainer>
      <NoteSocialSection {...responsiveProps} />
      <NoteAuthorSection {...props} />
      <NoteInfoAccordion
        {...responsiveProps}
        replyComment={replyComment}
        handleClick={handleClick}
      />

      <TitleLine />
      <NoteSocialSection {...props} />
      <TitleLine />
      {isCommentIconClicked && (
        <MakeCommentContainer>
          <MakeComment
            noteId={props.noteData._id}
            ref={commentInputRef}
            commentData={commentData}
            clearCommentData={clearCommentData}
          />
        </MakeCommentContainer>
      )}
    </NoteInfoContainer>
  );
};

export default NoteInfo;
